import React from "react";
import {
    Card,
    CardContent,
    Typography,
    Stack,
    Divider,
    IconButton,
    Box,
} from "@mui/material";
import SoftButton from "../../components/SoftButton";
import {SUPER_ADMIN} from "../../constants/constants";
import PropTypes from "prop-types";
import StatusChip from "../../reusableComponents/status/StatusChip";
import {formatDurationValue} from "../../utlis/generalUtils";
import {Delete} from "@mui/icons-material";
import {openBatch} from "./../../utlis/generalUtils";
import {useTranslation} from "react-i18next";


const BatchCard = ({ role, batch, onDeleteBatch}) => {
    const totalFiles = batch.files_count || 0;

    const { i18n } = useTranslation();
    const currentLang = i18n.language;

    return (
        <Card
            sx={{
                borderRadius: 4,
                p: 2,
                display: "flex",
                flexDirection: "column",
                boxShadow: "8px 8px 20px #d1d9e6, -8px -8px 20px #ffffff",
                transition: "all 0.3s ease-in-out",
                "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "12px 12px 24px #d1d9e6, -12px -12px 24px #ffffff",
                },
            }}
        >
            <CardContent
                sx={{
                    flex: 1,
                    overflowY: "auto",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: 1,
                        minHeight: "2.7rem",
                    }}
                >
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="h6" fontWeight="bold">
                            {batch.name}
                        </Typography>
                        <StatusChip status={batch.status} />
                    </Stack>

                </Box>

                <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

                <Stack direction="column" spacing={1} sx={{ pt: 1 }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="body2" color="text.main" fontWeight="medium">
                            Files Count:
                        </Typography>
                        <Typography variant="body2" color="text.main">{totalFiles}</Typography>
                    </Stack>

                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="body2" color="text.main" fontWeight="medium">
                            Created At:
                        </Typography>
                        <Typography variant="body2" color="text.main">
                            {batch.created_at ? new Date(batch.created_at).toLocaleString() : "-"}
                        </Typography>
                    </Stack>
                    {/*
                    {batch.status === "in_progress" && (
                        <ProgressBar value={completed} total={totalFiles} label="Completed" />
                    )}

                    {batch.status === "delivery_in_progress" && (
                        <ProgressBar value={delivered} total={totalFiles} label="Delivered" />
                    )}
                    */}
                    {batch.status === "delivered" && batch.delivered_at && (
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Typography variant="body2" color="text.main" fontWeight="medium">
                                Delivered At:
                            </Typography>
                            <Typography variant="body2" color="text.main">
                                {batch.delivered_at
                                    ? new Date(batch.delivered_at).toLocaleString()
                                    : "-"}
                            </Typography>
                        </Stack>
                    )}

                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="body2" color="text.main" fontWeight="medium">
                            Execution Time:
                        </Typography>
                        <Typography variant="body2" color="text.main">
                            {formatDurationValue(batch.execution_time)}
                        </Typography>
                    </Stack>
                </Stack>
            </CardContent>

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    p: 2,
                    pt: 1,
                    background: "#fff",
                    position: "sticky",
                    bottom: 0,
                }}
                >
                {role === SUPER_ADMIN && batch.status !== "loading" && (
                    <IconButton
                        size="small"
                        color="error"
                        variant="outlined"
                        sx={{
                            border: "1px solid transparent",
                            borderRadius: 1,
                            "&:hover": {
                                bgcolor: "rgba(244, 67, 54, 0.1)",
                                color: "error.main",
                            }}}
                        onClick={() => onDeleteBatch(batch)}
                    >
                        <Delete />
                    </IconButton>
                )}
                <SoftButton
                    size="small"
                    color="primary"
                    variant="outlined"
                    onClick={() => openBatch(batch.id, currentLang)}
                >
                    View Files
                </SoftButton>
            </Box>
        </Card>
    );
};

BatchCard.propTypes = {
    role: PropTypes.string,
    batch: PropTypes.object.isRequired,
    onDeleteBatch: PropTypes.func.isRequired,
};

export default BatchCard;
